import {
  FetchType,
  createApiFetcherWithErrorHandling,
} from '@/api/fetchers/createApiFetcherWithErrorHandling';
import { extractFromDataField } from '@/api/fetchers/extractFromDataField';

import { fetchClient, getClientApiDomain } from './fetchClient';

export const fetchApiClient = createApiFetcherWithErrorHandling(fetchClient, getClientApiDomain);

export const fetchApiClientDestructData: FetchType = async (...args) =>
  extractFromDataField(await fetchApiClient(...args));
